import { parse, stringify } from "flatted";

export default {
  data() {
    return {
      currentRoute: "",
      cachedData: {},
      persistedCache: false,
      cached: false,
      cacheExcludedFields: ["columns"],
    };
  },
  props: {
    cacheKey: String,
    noCache: Boolean,
  },
  computed: {
    cacheStore() {
      return this.persistedCache ? "persistedCache" : "cache";
    },
  },
  created() {
    if (window.localStorage.getItem("NO_CACHE") || this.noCache) return;
    this.persistedCache = this.$route.meta?.persistedCache || false;
    const route = `${this.$route.fullPath}`;
    let component = `${this.$options.name}`;
    if (this.cacheKey) {
      component += `#${this.cacheKey}`;
    }
    this.currentRoute = route;
    this.currentComponent = component;

    try {
      const getter =
        this.cacheStore === "persistedCache" ? "persistedCachedRoutes" : "cachedRoutes";
      const entry = this.$store.getters[`${this.cacheStore}/${getter}`]?.[route]?.[component];
      if (entry) {
        const cachedData = parse(entry);
        if (cachedData) {
          this.cachedData = cachedData;
          if (typeof this.restoreState === "function") {
            this.restoreState(cachedData);
          } else {
            this.setCachedState(this, cachedData);
          }
          this.cached = true;
        }
      }
    } catch (ignore) {
      console.warn(` invalid cachedetected for ${this.currentRoute}, cleaning it up`);
      this.$store.dispatch(`${this.cacheStore}/removePersistedCachedRoute`, this.currentRoute);
    }
  },
  async beforeDestroy() {
    if (this.noCache) return;
    await this.storeCache();
    delete this.cachedData;
  },
  methods: {
    async storeCache() {
      await this.$store.dispatch(`${this.cacheStore}/cleanIgnore`);
      if (this.noCache) return;
      if (this.currentRoute in this.$store.getters[`${this.cacheStore}/ignoreSave`]) return;

      let data;
      if (typeof this.saveState === "function") {
        data = this.saveState();
      } else {
        data = this.$data;
      }
      if (this.cacheExcludedFields && this.cacheExcludedFields.length > 0) {
        this.cacheExcludedFields.forEach((f) => delete data[f]);
      }

      try {
        await this.$store.dispatch(`${this.cacheStore}/cacheRoute`, {
          route: this.currentRoute,
          component: this.currentComponent,
          data: stringify(data),
        });
      } catch (error) {
        console.error(error);
      }
    },
    setCachedState(obj, cachedData) {
      for (let key in cachedData) {
        if (Object.prototype.hasOwnProperty.call(cachedData, key)) {
          obj[key] = cachedData[key];
        }
      }
    },
  },
};
